import AboutUs from './pages/AboutUs';
import Portfolio from './pages/Portfolio';
import Gallery from './pages/Gallery';
export var pages = {
  '.AboutUsPage': AboutUs,
  '.PortfolioPage': Portfolio,
  '.GalleryPage': Gallery
};